import api from '../api'

export default {
    namespaced:true,
    state:{
        complaintList:{
            beanList:[],
            total:0
        }
    },
    mutations:{
        setStateComplaintList(state,info){
            state.complaintList = info
        }
    },
    actions:{
        getComplaintList({commit},params){
            return api.post('/complaint/list','投诉列表',params).then(res=>{
                commit('setStateComplaintList',res.data)
            })
        },
        updateComplaint(store,params){
            return api.post('/complaint/update','处理投诉',params)
        }
    }
}